exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-icon[data-v-37172540]{cursor:pointer}", ""]);

// exports
